<div class="main-page-section default_font p-3 p-md-4 px-lg-5">
    <div class="breadcrumbs-section p-0 mb-3 mb-md-4 mb-lg-5">
        <span class="prev-page pr-1 prev"><a routerLink="/overview">Home</a></span>
        <span class="separator">&nbsp; &nbsp;</span>
        <img src="../../assets/images/seperator.png">
        <span class="separator">&nbsp; &nbsp;</span>
        <span class="curr-page pl-1 breadcrumbs-section-font">Create New Customer Service User</span>
    </div>
    <div class="d-flex align-items-center justify-content-between mb-3 mb-md-4">
        <h2 class="font-weight-medium mb-3 mb-md-4">Create New Customer Service User</h2>
    </div>

    <!-- form start -->
    <form [formGroup]="myForm" (ngSubmit)="onSubmit()" enctype="multipart/form-data">

        <div formArrayName="newUsersGroups">
            <div class="bg-lighter border border-light rounded p-3 p-md-4 mb-3 mb-md-4 position-relative"
                *ngFor="let item of newUsersGroups().controls; let i=index" [formGroupName]="i">
                <div class="row row-gap-4">
                    <div class="d-flex flex-column row-gap-1 col-12 col-md-4">
                        <div class="form-group floating_form_field mb-0 w-100">
                            <select class="form-control" formControlName="userid">
                                <option value="">Select Name</option>
                                <option value="{{userdata.memberId}}" *ngFor="let userdata of mainUserList">
                                    {{userdata.memberName}}
                                </option>
                            </select>
                            <label>Name</label>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div *ngIf="newUsersGroups().controls[i].get('userid').invalid && newUsersGroups().controls[i].get('userid').touched"
                                class="small text-danger">
                                <div *ngIf="newUsersGroups().controls[i].get('userid').errors?.required">
                                    Name is required
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex flex-column row-gap-1 col-12 col-md-4">
                        <div class="form-group floating_form_field mb-0 w-100">
                            <ng-select [items]="mainGroups" [multiple]="true" bindLabel="groupName"
                                [selectableGroup]="false" [closeOnSelect]="false" bindValue="groupId"
                                [virtualScroll]="false" (change)="selectGroupData($event)" (clear)="clearSelectedData()"
                                [clearable]="true" formControlName="groupid" (open)="onGroupSelectOpen(i)"
                                class="custom">
                                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                    <div class="custom-control custom-checkbox">
                                        <input id="item-{{index}}" type="checkbox" class="custom-control-input"
                                            name="item-{{index}}" [ngModel]="item$.selected"
                                            [ngModelOptions]="{standalone: true}">
                                        <label class="custom-control-label cursor-pointer">{{item.groupName}}</label>
                                    </div>
                                </ng-template>
                            </ng-select>
                            <label [ngClass]="groupSelectFocused && 'focused'">Assign Group</label>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div *ngIf="newUsersGroups().controls[i].get('groupid').invalid && newUsersGroups().controls[i].get('groupid').touched"
                                class="small text-danger">
                                <div *ngIf="newUsersGroups().controls[i].get('groupid').errors?.required">
                                    Group name is required
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="d-flex flex-column row-gap-1 col-12 col-md-4">
                        <div class="form-group floating_form_field mb-0 w-100">
                            <ng-select [items]="prakList" [multiple]="true" bindLabel="parkName"
                                [selectableGroup]="false" [closeOnSelect]="false" bindValue="parkId"
                                [virtualScroll]="false" (change)="selectParkData($event)"
                                (clear)="clearSelectedDataPark()" [clearable]="true" formControlName="parkid"
                                (open)="onParkSelectOpen(i)" class="custom">
                                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">

                                    <div class="custom-control custom-checkbox">
                                        <input id="item-{{index}}" type="checkbox" class="custom-control-input"
                                            name="item-{{index}}" [ngModel]="item$.selected"
                                            [ngModelOptions]="{standalone: true}">
                                        <label class="custom-control-label cursor-pointer">{{item.parkName}}</label>
                                    </div>
                                </ng-template>
                            </ng-select>
                            <label [ngClass]="parkSelectFocused && 'focused'">Assign IT Park</label>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div *ngIf="newUsersGroups().controls[i].get('parkid').invalid && newUsersGroups().controls[i].get('parkid').touched"
                                class="small text-danger">
                                <div *ngIf="newUsersGroups().controls[i].get('parkid').errors?.required">
                                    IT park name is required
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <button *ngIf="i !== 0" (click)="removeBlock(i)" class="btn btn-danger card_remove">
                    <svg-icon src="../../../assets/images/icons/close.svg"></svg-icon>
                </button>
            </div>
        </div>
        <div>
            <span class="text-primary font-weight-bold cursor-pointer" (click)="addMore()">+ Add More</span>
        </div>

        <div
            class="py-3 py-md-4 border-top border-light mt-3 mt-md-4 d-flex align-items-center justify-content-end column-gap-3">
            <button class="btn btn-clear text-muted" type="button" (click)="goToListPage()">Cancel</button>
            <button class="btn btn-primary" type="submit">Submit</button>
        </div>
    </form>
    <!-- form end -->
</div>